import PropTypes from 'prop-types';
import capitalize from '../capitalize';
import { userRoles } from 'utils/constants';

export const ownerShape = PropTypes.shape({
    uid: PropTypes.string,
    invite_id: PropTypes.string,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    vehicles: PropTypes.array,
    properties: PropTypes.object,
    role: PropTypes.string
});

export const normalizeOwners = ({
    members = [],
    nonResiMembers = [],
    invitedMembers = [],
    guests = [],
    orgPropertyId = null
} = {}) => {
    const normalized = [];

    for (const m of members || []) {
        const name = capitalize(`${m.first_name || ''} ${m.last_name || ''}`.trim());
        if (!name) continue;
        const associate = m.properties?.[orgPropertyId]?.role === userRoles.ASSOCIATE;
        normalized.push({
            uid: m.uid || null,
            invite_id: null,
            first_name: m.first_name,
            last_name: m.last_name,
            label: associate ? `${name} (Associate)` : name,
            vehicles: m.vehicles || [],
            properties: m.properties || {},
            role: associate ? userRoles.ASSOCIATE : m.role || null
        });
    }

    for (const m of nonResiMembers || []) {
        const name = capitalize(`${m.first_name || ''} ${m.last_name || ''}`.trim());
        if (!name) continue;
        normalized.push({
            uid: m.uid || null,
            invite_id: null,
            first_name: m.first_name,
            last_name: m.last_name,
            label: `${name} (Member)`,
            vehicles: m.vehicles || [],
            properties: m.properties || {},
            role: m.role || null
        });
    }

    for (const g of guests || []) {
        const name = capitalize(`${g.first_name || ''} ${g.last_name || ''}`.trim());
        if (!name) continue;
        normalized.push({
            uid: g.uid || null,
            invite_id: null,
            registration_id: null,
            first_name: g.first_name,
            last_name: g.last_name,
            label: `${name} (Guest)`,
            vehicles: g.vehicles || [],
            properties: g.properties || {},
            role: g.role || null
        });
    }

    for (const m of invitedMembers || []) {
        const name = capitalize(`${m.first_name || ''} ${m.last_name || ''}`.trim());
        if (!name) continue;
        normalized.push({
            uid: null,
            invite_id: m.invite_id || null,
            first_name: m.first_name,
            last_name: m.last_name,
            label: `${name} (Invited)`,
            vehicles: [],
            properties: m.property_id ? { [m.property_id]: {} } : {},
            role: m.role || null
        });
    }

    return normalized;
};
